
const digest = '82bcb7ee6a265c186f9751138bc2c9d79f1d45f4d42380b442f74063c7d815e6';
const classes = {"wrapper":"_wrapper_1jcf3_1","title":"_title_1jcf3_8"};
const css = `._wrapper_1jcf3_1 {
  border-bottom: 1px solid #eaedf3;
  border-right: 1px solid #eaedf3;
}
._wrapper_1jcf3_1 td {
  padding: 16px 18px;
}
._wrapper_1jcf3_1 ._title_1jcf3_8 {
  font-size: 14px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  